module.exports = __webpack_public_path__ + "assets/images/project/people/woman.svg?v=964d1461";